export enum PricingUpdateType {
    Unit = 1,
    Pack = 2
}
